export default __webpack_public_path__ + "static/media/jackpot6.9a27b3f9.png";